
import './index.less'

import { ReactComponent as UcsSvg } from 'bimui/dist/c1/icons/ucs_20.svg';
import { ReactComponent as LayerSvg } from 'bimui/dist/c1/icons/layer_20.svg';
import { ReactComponent as UndoSvg } from 'bimui/dist/c1/icons/undo_20.svg';
import { ReactComponent as RedoSvg } from 'bimui/dist/c1/icons/redo_20.svg';
import { ReactComponent as EditSvg } from 'bimui/dist/c1/icons/edit_20.svg';
import { ReactComponent as MoveSvg } from 'bimui/dist/c1/icons/move_20.svg';
import { ReactComponent as DeleteSvg } from 'bimui/dist/c1/icons/delete_20.svg';
import { ReactComponent as TrimExtendSvg } from 'bimui/dist/c1/icons/align_20.svg';
import { ReactComponent as ExtendSvg } from 'bimui/dist/c1/icons/extend_20.svg';
import { ReactComponent as TrimSvg } from 'bimui/dist/c1/icons/trim_20.svg';
import { ReactComponent as RotateSvg } from 'bimui/dist/c1/icons/rotate_20.svg';
import { ReactComponent as ExtrudeSvg } from 'bimui/dist/c1/icons/extrude_20.svg';
import { ReactComponent as ScaleSvg } from 'bimui/dist/c1/icons/scale_20.svg';
import { ReactComponent as FilletSvg } from 'bimui/dist/c1/icons/fillet_20.svg';
import { ReactComponent as ChamferSvg } from 'bimui/dist/c1/icons/chamfer_20.svg';
import { ReactComponent as CopySvg } from 'bimui/dist/c1/icons/copy_20.svg';
import { ReactComponent as RArraySvg } from 'bimui/dist/c1/icons/rectangular-array_20.svg';
import { ReactComponent as CArraySvg } from 'bimui/dist/c1/icons/circular-array_20.svg';
import { ReactComponent as PArraySvg } from 'bimui/dist/c1/icons/path-array_20.svg';
import { ReactComponent as MirrorSvg } from 'bimui/dist/c1/icons/mirror_20.svg';
import { ReactComponent as OffsetSvg } from 'bimui/dist/c1/icons/offset_20.svg';
import { ReactComponent as UnionSvg } from 'bimui/dist/c1/icons/union_20.svg';
import { ReactComponent as IntersectionSvg } from 'bimui/dist/c1/icons/intersection_20.svg';
import { ReactComponent as DiffSvg } from 'bimui/dist/c1/icons/difference_20.svg';
import { ReactComponent as TextSvg } from 'bimui/dist/c1/icons/text-size-setting_20.svg';
import { ReactComponent as TextAnnotationSvg } from 'bimui/dist/c1/icons/text-annotation_20.svg';
import { ReactComponent as TextOrthSvg } from 'bimui/dist/c1/icons/orthogonal-dimensioning_20.svg';
import { ReactComponent as TextAngleSvg } from 'bimui/dist/c1/icons/angle-dimensioning_20.svg';
import { ReactComponent as TextRadiusSvg } from 'bimui/dist/c1/icons/radius-dimensioning_20.svg';
import { ReactComponent as ShowSelectSvg } from 'bimui/dist/c1/icons/selected-display_20.svg';
import { ReactComponent as ShowReverseSvg } from 'bimui/dist/c1/icons/reverse-display_20.svg';
import { ReactComponent as ShowAllSvg } from 'bimui/dist/c1/icons/display-all_20.svg';
import { ReactComponent as ArrowSvg } from 'bimui/dist/c1/icons/dropdown.svg';
import { ReactComponent as AxisNumber20Svg } from 'bimui/dist/c1/icons/axis-numbering_20.svg';
import { ReactComponent as Orthogonal20Svg } from 'bimui/dist/c1/icons/orthogonal-dimensioning_20.svg';
import { ReactComponent as Slant20Svg } from 'bimui/dist/c1/icons/slant_20.svg';

import { ReactComponent as PanViewSvg } from './icons/pan.svg'
import { ReactComponent as RotateViewSvg } from './icons/rotate.svg'
import { ReactComponent as ZoomAllSvg } from './icons/zoom-all.svg'

// 块、组
import { ReactComponent as BlockSvg } from 'bimui/dist/c1/icons/block_20.svg'
import { ReactComponent as GroupSvg } from 'bimui/dist/c1/icons/group_20.svg'

// 线
import { ReactComponent as LineSvg } from 'bimui/dist/c1/icons/line_20.svg'
import { ReactComponent as PlineSvg } from 'bimui/dist/c1/icons/pline_20.svg'
import { ReactComponent as CircleSvg } from 'bimui/dist/c1/icons/circle_20.svg'
import { ReactComponent as ArcSvg } from 'bimui/dist/c1/icons/arc_20.svg'
import { ReactComponent as EllipseSvg } from 'bimui/dist/c1/icons/ellipse_20.svg'
import { ReactComponent as RectangleSvg } from 'bimui/dist/c1/icons/rectangle_20.svg'
import { ReactComponent as SplineCurveSvg } from 'bimui/dist/c1/icons/spline-curve_20.svg'

// 面
import { ReactComponent as PointEnclosedSurfaceSvg } from 'bimui/dist/c1/icons/point-enclosed-surface_20.svg'
import { ReactComponent as LineEnclosedSurfaceSvg } from 'bimui/dist/c1/icons/line-enclosed-surface_20.svg'
import { ReactComponent as SphereSurfaceSvg } from 'bimui/dist/c1/icons/sphere_surface_20.svg'
import { ReactComponent as ExtrudedSurfaceSvg } from 'bimui/dist/c1/icons/extruded-surface_20.svg'
import { ReactComponent as SurfaceSvg } from 'bimui/dist/c1/icons/surface_20.svg'

// 体
import { ReactComponent as BoxSvg } from 'bimui/dist/c1/icons/box_20.svg'
import { ReactComponent as CylinderSvg } from 'bimui/dist/c1/icons/cylinder_20.svg'
import { ReactComponent as RingSvg } from 'bimui/dist/c1/icons/ring_20.svg'
import { ReactComponent as ConeSvg } from 'bimui/dist/c1/icons/cone_20.svg'
import { ReactComponent as PyramidSvg } from 'bimui/dist/c1/icons/pyramid_20.svg'
import { ReactComponent as FrustumSvg } from 'bimui/dist/c1/icons/frustum_20.svg'
import { ReactComponent as WedgeSvg } from 'bimui/dist/c1/icons/wedge_20.svg'
import { ReactComponent as ExtrudedBodySvg } from 'bimui/dist/c1/icons/extruded-body_20.svg'
import { ReactComponent as RevolveBodySvg } from 'bimui/dist/c1/icons/rotator_20.svg'
import { ReactComponent as SphereBodySvg } from 'bimui/dist/c1/icons/sphere_20.svg'

// 约束
import { ReactComponent as ParallelSvg } from 'bimui/dist/c1/icons/parallel_20.svg'
import { ReactComponent as EqualSvg } from 'bimui/dist/c1/icons/equal_20.svg'
import { ReactComponent as AlighmentSvg } from 'bimui/dist/c1/icons/alighment_20.svg'
import { ReactComponent as CommonCenterSvg } from 'bimui/dist/c1/icons/common-center_20.svg'
import { ReactComponent as CollinearSvg } from 'bimui/dist/c1/icons/collinear_20.svg'
import { ReactComponent as FixedDistanceSvg } from 'bimui/dist/c1/icons/fixed-distance_20.svg'

import { ReactComponent as ShowUcsSvg } from 'bimui/dist/c1/icons/show_ncs_20.svg'
import { ReactComponent as HideUcsSvg } from 'bimui/dist/c1/icons/hide_ncs_20.svg'


import { useContext, useEffect, useRef, useState, } from 'react'
import LayerManage from '@/components/layer/LayerManage';
import UcsManage from '@/components/ucs/UcsManage';
import { EngineContext, RegisterContext } from '@/App'
import { AxesPrimitive, BlockPrimitive, CameraPerspectiveType, DataChangeStruct, PythaEngineControl, PythaEventDataChange, PythaEventEnd, PythaEventName, PythaEventSetting, PythaEventZoomAll, SETTING_KEY, UpdateType } from 'pytha2'
import { findAxesListInGraphic } from '@/declare/api/geometry/axes'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, ContextMenu, ContextMenuModal, ContextMenuWrapper, Dropdown, IconButton, MenuItem, MenuList } from 'bimui'
import ColorPalettePanel from './color-palette-panel';
import { Modal } from 'bimui';
import ColorPalette from './color-palette-modal';
import { Color, SplineCurve } from "three";
import { updateLayer } from '@/declare/api/geometry/layer';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import React from 'react';
import ToolMenu from './tool-menu';
import { message } from 'antd';
import { SIDEBAR_TYPE, TOOL_TYPE } from '@/declare/enums/menu-type';


/**
 * `OperationBar` 组件
 * 提供常用工具的操作面板，包括图层管理和 UCS（用户坐标系）切换功能，以及平移、旋转、缩放图元等操作按钮
 */
export default function OperationBar() {

    const { projectUuid } = useParams();

    const registerContext = useContext(RegisterContext);
    const location = useLocation();
    const navigate = useNavigate();

    /**
     * 从全局的 EngineContext 中获取命令触发函数 `emitCommand`
     * - 用于向引擎发送指令。
     */
    const { emitCommand, layers, setCurrentLayerUuid, currentLayerUuid, engine, setLayers } = useContext(EngineContext);

    /**
     * 下拉框显示的当前图层id 如果有选中图元 则要修改显示
     */
    const [displayLayerUuid, setDisplayLayerUuid] = useState<string>(currentLayerUuid || '');
    /**
     * 是否显示图层管理面板
     */
    const [showLayerManage, setShowLayerManage] = useState<boolean>(false);
    /**
     * 是否显示 UCS（用户坐标系）管理面板
     */
    const [showUcsManage, setShowUcsManage] = useState<boolean>(false);
    /**
     * 是否显示倒角菜单
     */
    const [showChamferMenu, setShowChamferMenu] = useState<boolean>(false);
    /**
     * 是否显示操作图元菜单（复制、矩形阵列、环形阵列、沿线阵列、镜像、偏移）
     */
    const [showOperateMenu, setShowOperateMenu] = useState<boolean>(false);
    /**
     * 是否显示文字菜单
     */
    const [showTextMenu, setShowTextMenu] = useState<boolean>(false);
    /**
     * 是否显示标注菜单
     */
    const [showAnnoMenu, setShowAnnoMenu] = useState<boolean>(false);
    /**
     * 菜单的left
     */
    const [left, setLeft] = useState(0);
    /**
     * 菜单的top
     */
    const [top, setTop] = useState(0);

    const [selectedChamferIcon, setSelectedChamferIcon] = useState(<FilletSvg />); // 当前选中的图标
    const [selectedOperateIcon, setSelectedOperateIcon] = useState(<CopySvg />); // 当前选中的图标
    const [selectedTextIcon, setSelectedTextIcon] = useState(<TextSvg />); // 当前选中的图标
    const [selectedAnnoIcon, setSelectedAnnoIcon] = useState(<Orthogonal20Svg />); // 当前选中的图标

    const [selectedBlockGroupIcon, setSelectedBlockGroupIcon] = useState({ key: "block", icon: <BlockSvg /> }); // 块组下拉选项中当前选中的图标
    const [selectedLineIcon, setSelectedLineIcon] = useState({ key: "line", icon: <LineSvg /> }); // 线下拉选项中当前选中的图标
    const [selectedViewIcon, setSelectedVieweIcon] = useState({ key: "top", icon: <span className='view-icon'>上</span> }); // 线下拉选项中当前选中的图标
    const [selectedMeshIcon, setSelectedMeshIcon] = useState({ key: "region", icon: <PointEnclosedSurfaceSvg /> }); // 面下拉选项中当前选中的图标
    const [selectedSolidIcon, setSelectedSolidIcon] = useState({ key: "BOX", icon: <BoxSvg /> }); // 体下拉选项中当前选中的图标
    const [selectedConstraintIcon, setSelectedConstraintIcon] = useState({ key: "Parallel", icon: <ParallelSvg /> }); // 约束下拉选项中当前选中的图标
    const [selectedBoolIcon, setSelectedBoolIcon] = useState({ key: "Union", icon: <UnionSvg /> }); // 布尔操作下拉选项中当前选中的图标


    const [displayColor, setDisplayColor] = useState<string>('#ffba84'); // 当前工具栏展示颜色
    const [isMixColor, setIsMixColor] = useState<boolean>(false); // 是否同时有多种颜色 （多个构件选中）
    const [showUcs, setShowUcs] = useState<boolean>(false); // 是否渲染坐标系

    /**
     * 控制颜色下拉菜单的显示与隐藏
     */
    const [colorDropVisible, setColorDropVisible] = useState(false);
    /**
     * 控制调色板模态框的显示与隐藏
     */
    const [paletteModalVisible, setPaletteModalVisible] = useState(false);

    const onColorChange = (color: string) => {
        setColorDropVisible(false);
        setPaletteModalVisible(false);
        if (!engine) return;
        if (engine.storage?.selectStore.getUnlockedPrimitives().length > 0) {
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.COLOR,
                value: color,
            }
            engine.eventMediator?.emitEvent(event);
        }
    }

    /**
     * 监听引擎发出的事件，修改图层显示、颜色显示
     */
    useEffect(() => {
        // 监听引擎事件
        if (engine == null) return;
        const unsubscribe = engine.eventMediator.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.DATA_CHANGE) {

                let data = event?.data as DataChangeStruct;
                if (!data) return;

                // 监听选择变更
                if (data.selectChanged) {
                    syncColor();
                    if (engine.storage?.selectStore.selectPrimitives.length > 0) {
                        let uuid = engine.storage?.selectStore.selectPrimitives[0].layerUuid;
                        let flag = true;
                        for (let pri of engine.storage?.selectStore.selectPrimitives) {
                            if (pri.layerUuid != uuid) {
                                setDisplayLayerUuid("")
                                flag = false;
                                break;
                            }
                        }
                        if (flag) {
                            setDisplayLayerUuid(uuid);
                        }
                    } else {
                        setDisplayLayerUuid(currentLayerUuid);
                    }
                }
                // 监听图层更新
                if (data.update_layer) {
                    let layer = data.update_layer;
                    let idx = layers.findIndex(item => item.uuid == layer.uuid);
                    if (idx >= 0) {
                        let res = [...layers];
                        res.splice(idx, 1, layer);
                        setLayers([
                            ...res,
                        ])
                    }
                    if (layer.uuid === currentLayerUuid) {
                        syncColor();
                    }
                    updateLayer(projectUuid, layer).then(res => {

                    })
                }
            }
        });

        return () => {
            unsubscribe?.();
        };
    }, [engine, layers, projectUuid, currentLayerUuid]);

    /**
     * 同步颜色
     */
    const syncColor = () => {
        let color = engine.storage?.layerStore.getColor();
        // 同步颜色
        let selectedPrimitives = engine.storage?.selectStore.selectPrimitives || [];
        if (selectedPrimitives.length <= 0) {
            setDisplayColor(color);
            setIsMixColor(false);
            return;
        }
        let tmpColor: Color = null;
        let flag = false; // 判断是否颜色不同
        for (let pri of selectedPrimitives) {
            if (pri.type === "Block") {
                let block = pri as BlockPrimitive;
                let bt = engine.storage?.blockStore.blockTemplateDict[block.blockTemplateUuid];
                for (let key in bt.materials) {
                    let mat = bt.materials[key];
                    if (tmpColor == null) {
                        tmpColor = mat.color.clone();
                        continue;
                    }
                    if (tmpColor.getHexString() != mat.color.getHexString()) {
                        setIsMixColor(true);
                        flag = true;
                        break;
                    }
                    tmpColor.copy(mat.color);
                }
                if (flag) {
                    setDisplayColor(color);
                    break;
                }
            } else {
                for (let key in pri.materials) {
                    let mat = pri.materials[key];
                    if (tmpColor == null) {
                        tmpColor = mat.color.clone();
                        continue;
                    }
                    if (tmpColor.getHexString() != mat.color.getHexString()) {
                        setIsMixColor(true);
                        flag = true;
                        break;
                    }
                    tmpColor.copy(mat.color);
                }
                if (flag) {
                    setDisplayColor(color);
                    break;
                }
            }
        }
        if (!flag) {
            setDisplayColor(`#${tmpColor?.getHexString()}`);
        }
    }


    useEffect(() => {
        document.addEventListener('keydown', onKeydown);
        return () => {
            document.removeEventListener('keydown', onKeydown);
        }
    }, [])

    /**
     * 监听全局esc 调整工具栏状态
     * @param e 
     * @returns 
     */
    const onKeydown = (e) => {
        const code = e.code;
        if (code === "Escape") {
            setColorDropVisible(false);
            setPaletteModalVisible(false);
            setDisplayLayerUuid(currentLayerUuid)
            return;
        }
    }

    /**
     * 切换图层的方法
     * - 用户通过界面选择新的图层时调用此方法。
     * 
     * @param value 新选中的图层 UUID
     */
    const handleLayerChange = (value: string) => {
        // 判断当前有无选中图元
        let layer = layers.find(item => item.uuid === value);
        if (engine && engine.storage.selectStore.selectPrimitives.length > 0) {
            // 当前有选中图元，则修改图元的图层
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.LAYER_CHANGE,
                value: layer,
            }
            engine.eventMediator?.emitEvent(event);
        }
        setCurrentLayerUuid(value);
        setDisplayLayerUuid(value);
    };

    // useEffect(() => {
    //     if (engine && engine.storage.selectStore.selectPrimitives.length > 0) {
    //         // 当前有选中图元 不修改显示
    //     } else {
    //         setDisplayLayerUuid(currentLayerUuid);
    //     }
    // }, [currentLayerUuid])


    /**
     * 调整视图将全部图元显示在视图区
     */
    const clickZoomAll = () => {
        const pythaEvent = new PythaEventZoomAll();
        pythaEvent.data = {};
        engine.eventMediator?.emitEvent(pythaEvent);
    }

    /**
     * 点击倒角功能列表显示的图标，激活对应的功能
     */
    const handleChamferIconClick = () => {
        if (selectedChamferIcon.type === FilletSvg) {
            emitCommand("FILLET"); // 默认执行 DTEXT
        } else if (selectedChamferIcon.type === ChamferSvg) {
            emitCommand("CHAMFER"); // 执行标注文字
        }
    };

    /**
     * 点击常规图圆操作功能列表显示的图标，激活对应的功能
     */
    const handleOperateIconClick = () => {
        if (selectedOperateIcon.type === CopySvg) {
            emitCommand("COPY");
            if (!registerContext.isSidebarCollapsed) {
                emitter.emit(Emit_Event_Common_Tool.COPY);
            }
        } else if (selectedOperateIcon.type === RArraySvg) {
            emitCommand("RECTARRAY");
        } else if (selectedOperateIcon.type === CArraySvg) {
            emitCommand("POLARARRAY");
        } else if (selectedOperateIcon.type === PArraySvg) {
            emitCommand("PATHARRAY");
        } else if (selectedOperateIcon.type === MirrorSvg) {
            emitCommand("MIRROR");
        } else if (selectedOperateIcon.type === OffsetSvg) {
            emitCommand("OFFSET");
        }
    };

    /**
     * 点击文字操作功能列表显示的图标，激活对应的功能
     */
    const handleTextIconClick = () => {
        if (selectedTextIcon.type === TextSvg) {
            emitCommand("DTEXT");
        } else if (selectedTextIcon.type === TextAnnotationSvg) {
            message.info("TODO 暂未上线")
        } else if (selectedTextIcon.type === AxisNumber20Svg) {
            emitCommand("GENGRIDNUMBER");
        }
    };

    /**
     * 点击标注操作功能列表显示的图标，激活对应的功能
     */
    const handleAnnoIconClick = () => {
        if (selectedAnnoIcon.type === Orthogonal20Svg) {
            message.info("TODO 暂未上线")
        } else if (selectedAnnoIcon.type === Slant20Svg) {
            message.info("TODO 暂未上线")
        } else if (selectedAnnoIcon.type === TextAngleSvg) {
            message.info("TODO 暂未上线")
        } else if (selectedAnnoIcon.type === TextRadiusSvg) {
            message.info("TODO 暂未上线")
        }
    };

    /**
     * 点击块组操作功能列表显示的图标，激活对应的功能
     */
    const handleBlockGroupIconClick = (item) => {
        setSelectedBlockGroupIcon(item)
        if (item.key === "block") {
            registerContext.activeTool(TOOL_TYPE.BLOCK);
        } else if (item.key == "group") {
            registerContext.activeSidebar("group");
        }
    }
    /**
     * 点击线操作功能列表显示的图标，激活对应的功能
     */
    const handleLineIconClick = (item) => {
        setSelectedLineIcon(item)
        if (item.key === "line") {
            emitCommand('LINE')
        } else if (item.key === "pline") {
            emitCommand('PLINE')
        } else if (item.key === "circle") {
            emitCommand('CIRCLE')
        } else if (item.key === "arc") {
            emitCommand('ARC')
        } else if (item.key === "ellipse") {
            emitCommand('ELLIPSE')
        } else if (item.key === "rectangle") {
            emitCommand('RECTANGLE')
        } else if (item.key === "splineCurve") {
            // 样条曲线
            message.info("TODO 暂未上线")
        }
    }

    /**
     * 点击视图按钮
     * @param item 
     */
    const handleViewIconClick = (item) => {
        setSelectedVieweIcon(item)
        if (item.key === "top") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.UP,
            }
            engine.eventMediator?.emitEvent(event);
        } else if (item.key === "bottom") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.DOWN,
            }
            engine.eventMediator?.emitEvent(event);
        } else if (item.key === "front") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.FRONT,
            }
            engine.eventMediator?.emitEvent(event);
        } else if (item.key === "back") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.BACK,
            }
            engine.eventMediator?.emitEvent(event);
        } else if (item.key === "left") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.LEFT,
            }
            engine.eventMediator?.emitEvent(event);
        } else if (item.key === "right") {
            emitCommand('CHANGE_CAMERA_PERSPECTIVE');
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CAMERA_PERSPECTIVE,
                value: CameraPerspectiveType.RIGHT,
            }
            engine.eventMediator?.emitEvent(event);
        }
    }

    /**
     * 点击面操作功能列表显示的图标，激活对应的功能
     */
    const handleMeshIconClick = (item) => {
        setSelectedMeshIcon(item);
        if (item.key === "region") {
            emitCommand('REGION')
        } else if (item.key === "lineRegion") {
            // 多线围合面
            message.info("TODO 暂未上线")
        } else if (item.key === "sphere") {
            emitCommand('SPHERE')
        } else if (item.key === "extrude") {
            emitCommand('EXTRUDE')
        } else if (item.key === "revolve") {
            // 旋转面
            emitCommand('REVOLVE')
        }
    }

    /**
     * 点击体操作功能列表显示的图标，激活对应的功能
     */
    const handleSolidIconClick = (item) => {
        setSelectedSolidIcon(item)
        if (item.key === "BOX") {
            emitCommand('BOX')
        } else if (item.key === "CYLINDER") {
            emitCommand('CYLINDER')
        } else if (item.key === "TORUS") {
            emitCommand('TORUS')
        } else if (item.key === "CONE") {
            emitCommand('CONE')
        } else if (item.key === "PYRAMID") {
            // 棱锥
            emitCommand('PYRAMID')
        } else if (item.key === "FRUSTUM") {
            // 棱台
            message.info("TODO 暂未上线")
        } else if (item.key === "WEDGE") {
            emitCommand('WEDGE')
        } else if (item.key === "EXTRUDE") {
            emitCommand('EXTRUDE')
        } else if (item.key === "REVOLVE") {
            emitCommand('REVOLVE')
        } else if (item.key === "SPHERE") {
            emitCommand('SPHERE')
        }
    }

    /**
     * 点击约束操作功能列表显示的图标，激活对应的功能
     */
    const handleConstrintIconClick = (item) => {
        setSelectedConstraintIcon(item)
        if (item.key === "Parallel") {
            message.info("TODO 暂未上线")
        } else if (item.key === "EqualS") {
            message.info("TODO 暂未上线")
        } else if (item.key === "Alighment") {
            message.info("TODO 暂未上线")
        } else if (item.key === "CommonCenter") {
            message.info("TODO 暂未上线")
        } else if (item.key === "Collinear") {
            message.info("TODO 暂未上线")
        } else if (item.key === "FixedDistance") {
            message.info("TODO 暂未上线")
        }
    }

    /**
     * 点击布尔操作功能列表显示的图标，激活对应的功能
     */
    const handleBoolIconClick = (item) => {
        setSelectedBoolIcon(item)
        if (item.key === "Union") {
            message.info("TODO 暂未上线")
        } else if (item.key === "Intersection") {
            message.info("TODO 暂未上线")
        } else if (item.key === "Diff") {
            message.info("TODO 暂未上线")
        }
    }


    return (
        <div className="operation-bar-container">
            {/* 状态 */}
            {/* <div className='status-container'>
                <IconButton icon={<StatusSvg />} onClick={() => {
                    message.info("打开状态侧边栏")
                }}></IconButton>
                <div className="status-name"><div className="status-name-text">设计</div></div>
            </div> */}

            {/* 图层 */}
            <div className='layer-select-container'>
                <IconButton icon={<LayerSvg />} onClick={() => {
                    let endEvent = new PythaEventEnd();
                    engine?.eventMediator?.emitEvent(endEvent);
                    setShowLayerManage(true)
                }}></IconButton>
                <Dropdown
                    options={layers.map(layer => ({
                        value: layer.uuid,
                        label: layer.name
                    }))}
                    onChange={(value) => handleLayerChange(value)}
                    value={displayLayerUuid}
                    placeholder='图层'
                />

            </div>
            <ContextMenuWrapper
                width={220}
                visible={colorDropVisible}
                onVisibleChange={(visible) => setColorDropVisible(visible)}
                container={(
                    <Button wrapClassName='color-btn'>
                        <div style={{
                            backgroundColor: `${displayColor}`,
                            width: '20px',
                            height: '20px'
                        }}>
                            {isMixColor && "?"}
                        </div>
                    </Button>
                )}>
                <ColorPalettePanel
                    onColorClick={(color: string) => onColorChange(color)}
                    onModalClick={() => {
                        setColorDropVisible(false);
                        setPaletteModalVisible(true);
                    }} />
            </ContextMenuWrapper>

            <IconButton icon={<UndoSvg />} onClick={() => { emitCommand("UNDO") }}></IconButton>
            <IconButton icon={<RedoSvg />} onClick={() => { emitCommand("REDO") }}></IconButton>
            <div className='tool-bar-divider'></div>


            <IconButton icon={<BlockSvg />} active={
                registerContext.currentActivedToolKey === TOOL_TYPE.BLOCK || location.pathname.includes("blocks")
            } onClick={() => {
                // 没有激活的时候才可以拉出工具栏
                if (registerContext.currentActivedToolKey !== TOOL_TYPE.BLOCK &&
                    location.pathname.includes('models')) {
                    registerContext.activeTool(TOOL_TYPE.BLOCK);
                    return;
                }
                // 模型区已经激活工具栏就不需要管
                if (location.pathname.includes('models')) return;
                // 跳转到编辑页签
                registerContext.activeSidebar(SIDEBAR_TYPE.BLOCK);
                navigate(`/projects/${projectUuid}/blocks`);
            }}></IconButton>

            {/* 块、组 */}
            {/* <ToolMenu
                idKey="block-group"
                icons={[
                    { key: "block", icon: <BlockSvg /> },
                    { key: "group", icon: <GroupSvg /> }]}
                selectedIcon={selectedBlockGroupIcon}
                handleIconClick={(item) => handleBlockGroupIconClick(item)}
            /> */}
            {/* 线 */}
            <ToolMenu
                idKey="line"
                icons={[
                    { key: "line", icon: <LineSvg /> },
                    { key: "pline", icon: <PlineSvg /> },
                    { key: "circle", icon: <CircleSvg /> },
                    { key: "arc", icon: <ArcSvg /> },
                    { key: "ellipse", icon: <EllipseSvg /> },
                    { key: "rectangle", icon: <RectangleSvg /> },
                    { key: "splineCurve", icon: <SplineCurveSvg /> }
                ]}
                selectedIcon={selectedLineIcon}
                handleIconClick={(icon) => handleLineIconClick(icon)}
            />
            {/* 面 */}
            <ToolMenu
                idKey="mesh"
                icons={[
                    { key: "region", icon: <PointEnclosedSurfaceSvg /> },
                    { key: "lineRegion", icon: <LineEnclosedSurfaceSvg /> },
                    { key: "sphere", icon: <SphereSurfaceSvg /> },
                    { key: "extrude", icon: <ExtrudedSurfaceSvg /> },
                    { key: "revolve", icon: <SurfaceSvg /> }
                ]}
                selectedIcon={selectedMeshIcon}
                handleIconClick={(icon) => handleMeshIconClick(icon)}
            />
            {/* 体 */}
            <ToolMenu
                idKey="solid"
                icons={[
                    { key: "BOX", icon: <BoxSvg /> },
                    { key: "CYLINDER", icon: <CylinderSvg /> },
                    { key: "TORUS", icon: <RingSvg /> },
                    { key: "CONE", icon: <ConeSvg /> },
                    { key: "PYRAMID", icon: <PyramidSvg /> },
                    // { key: "FRUSTUM", icon: <FrustumSvg /> },
                    { key: "WEDGE", icon: <WedgeSvg /> },
                    { key: "EXTRUDE", icon: <ExtrudedBodySvg /> },
                    { key: "REVOLVE", icon: <RevolveBodySvg /> },
                    { key: "SPHERE", icon: <SphereBodySvg /> },
                ]}
                selectedIcon={selectedSolidIcon}
                handleIconClick={(icon) => handleSolidIconClick(icon)}
            />
            {/* 约束 */}
            <ToolMenu
                idKey="constraint"
                icons={[
                    { key: "Parallel", icon: <ParallelSvg /> },
                    { key: "EqualS", icon: <EqualSvg /> },
                    { key: "Alighment", icon: <AlighmentSvg /> },
                    { key: "CommonCenter", icon: <CommonCenterSvg /> },
                    { key: "Collinear", icon: <CollinearSvg /> },
                    { key: "FixedDistance", icon: <FixedDistanceSvg /> }
                ]}
                selectedIcon={selectedConstraintIcon}
                handleIconClick={(icon) => handleConstrintIconClick(icon)}
            />
            <div className='tool-bar-divider'></div>

            <IconButton icon={<EditSvg />} onClick={() => { if (!registerContext.isSidebarCollapsed) { emitter.emit(Emit_Event_Common_Tool.EDIT); } }}></IconButton>
            <IconButton icon={<MoveSvg />} onClick={() => { emitCommand("MOVE") }}></IconButton>
            <IconButton icon={<DeleteSvg />} onClick={() => {
                emitCommand("DELETE");
                if (!registerContext.isSidebarCollapsed) {
                    emitter.emit(Emit_Event_Common_Tool.DELETE);
                }
            }}></IconButton>
            <IconButton icon={<TrimSvg />} onClick={() => { emitCommand("TRIM") }}></IconButton>
            <IconButton icon={<ExtendSvg />} onClick={() => { emitCommand("EXTEND") }}></IconButton>
            <IconButton icon={<RotateSvg />} onClick={() => { emitCommand("ROTATE") }}></IconButton>
            <IconButton icon={<ExtrudeSvg />} onClick={() => { emitCommand("EXTRUDE") }}></IconButton>
            <IconButton icon={<ScaleSvg />} onClick={() => { emitCommand("SCALE") }}></IconButton>

            <div id='operation-bar-chamfer-btn'>
                <IconButton icon={selectedChamferIcon} onClick={handleChamferIconClick} style={{ width: 40 }}>
                    <ArrowSvg onClick={(e) => {
                        e.stopPropagation();
                        let dom = document.getElementById('operation-bar-chamfer-btn');
                        let rect = dom.getBoundingClientRect();
                        setTop(rect.top + 32);
                        setLeft(rect.left - 5);
                        setShowChamferMenu(true);
                    }} />
                </IconButton>
            </div>

            <div id='operation-bar-operate-btn'>
                <IconButton icon={selectedOperateIcon} onClick={handleOperateIconClick} style={{ width: 40 }}>
                    <ArrowSvg onClick={(e) => {
                        e.stopPropagation();
                        let dom = document.getElementById('operation-bar-operate-btn');
                        let rect = dom.getBoundingClientRect();
                        setTop(rect.top + 32);
                        setLeft(rect.left - 5);
                        setShowOperateMenu(true);
                    }} />
                </IconButton>
            </div>

            <div className='tool-bar-divider'></div>
            {/* <IconButton icon={<UnionSvg />} onClick={() => { }}></IconButton>
            <IconButton icon={<IntersectionSvg />}></IconButton>
            <IconButton icon={<DiffSvg />}></IconButton> */}
            {/* 布尔操作 */}
            <ToolMenu
                idKey="bool"
                icons={[
                    { key: "Union", icon: <UnionSvg /> },
                    { key: "Intersection", icon: <IntersectionSvg /> },
                    { key: "Diff", icon: <DiffSvg /> }
                ]}
                selectedIcon={selectedBoolIcon}
                handleIconClick={(icon) => handleBoolIconClick(icon)}
            />
            <div className='tool-bar-divider'></div>

            <div id='operation-bar-text-btn'>
                <IconButton icon={selectedTextIcon} onClick={handleTextIconClick} style={{ width: 40 }}>
                    <ArrowSvg onClick={(e) => {
                        e.stopPropagation();
                        let dom = document.getElementById('operation-bar-text-btn');
                        let rect = dom.getBoundingClientRect();
                        setTop(rect.top + 32);
                        setLeft(rect.left - 5);
                        setShowTextMenu(true);
                    }} />
                </IconButton>
            </div>

            <div id='operation-bar-anno-btn'>
                <IconButton icon={selectedAnnoIcon} onClick={handleAnnoIconClick} style={{ width: 40 }}>
                    <ArrowSvg onClick={(e) => {
                        e.stopPropagation();
                        let dom = document.getElementById('operation-bar-anno-btn');
                        let rect = dom.getBoundingClientRect();
                        setTop(rect.top + 32);
                        setLeft(rect.left - 5);
                        setShowAnnoMenu(true);
                    }} />
                </IconButton>
            </div>

            <div className='tool-bar-divider'></div>
            <IconButton icon={<ShowSelectSvg />} onClick={() => { emitCommand("SHOW_SELECTED") }} ></IconButton>
            <IconButton icon={<ShowReverseSvg />} onClick={() => { emitCommand("HIDDEN_SELECTED") }}></IconButton>
            <IconButton icon={<ShowAllSvg />} onClick={() => { emitCommand("SHOW_ALL") }}></IconButton>

            <div className='tool-bar-divider'></div>
            <IconButton icon={<PanViewSvg />} onClick={() => { emitCommand('PAN'); }} ></IconButton>
            <IconButton icon={<RotateViewSvg />} onClick={() => { emitCommand('3DO'); }}></IconButton>
            <IconButton icon={<ZoomAllSvg />} onClick={() => { clickZoomAll() }}></IconButton>

            <ToolMenu
                idKey="view"
                icons={[
                    { key: "top", icon: <span className='view-icon'>上</span> },
                    { key: "bottom", icon: <span className='view-icon'>下</span> },
                    { key: "front", icon: <span className='view-icon'>前</span> },
                    { key: "back", icon: <span className='view-icon'>后</span> },
                    { key: "left", icon: <span className='view-icon'>左</span> },
                    { key: "right", icon: <span className='view-icon'>右</span> },
                ]}
                selectedIcon={selectedViewIcon}
                handleIconClick={(icon) => handleViewIconClick(icon)}
            />
            <IconButton onClick={() => {
                // 设置世界坐标系隐藏
                if (engine) {
                    let pythaEventKeep = new PythaEventSetting();
                    pythaEventKeep.data = { key: SETTING_KEY.AXES_KEEP, value: null }
                    engine?.eventMediator?.emitEvent(pythaEventKeep);
                    setShowUcs(pre => !pre);
                }
            }}>{showUcs ? <ShowUcsSvg /> : <HideUcsSvg />}</IconButton>
            {/* 
            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.UP,
                }
                engine.eventMediator?.emitEvent(event);
            }}>上</IconButton>

            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.DOWN,
                }
                engine.eventMediator?.emitEvent(event);
            }}>下</IconButton>

            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.FRONT,
                }
                engine.eventMediator?.emitEvent(event);
            }}>前</IconButton>

            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.BACK,
                }
                engine.eventMediator?.emitEvent(event);
            }}>后</IconButton>

            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.LEFT,
                }
                engine.eventMediator?.emitEvent(event);
            }}>左</IconButton>

            <IconButton onClick={() => {
                emitCommand('CHANGE_CAMERA_PERSPECTIVE');
                let event = new PythaEventSetting();
                event.data = {
                    key: SETTING_KEY.CAMERA_PERSPECTIVE,
                    value: CameraPerspectiveType.RIGHT,
                }
                engine.eventMediator?.emitEvent(event);
            }}>右</IconButton> */}

            <Modal
                title="图层管理"
                open={showLayerManage}
                showFooter={false}
                width={700}
                mask
                onCancel={() => setShowLayerManage(false)}>
                <LayerManage />
            </Modal>


            <Modal
                title="选择颜色"
                open={paletteModalVisible}
                width={600}
                showFooter={false}
                wrapClassName="color-select-modal"
                onCancel={() => setPaletteModalVisible(false)}
            >
                <div className="color-select-modal-body">
                    <ColorPalette
                        onComplete={(color: string) => onColorChange(color)}
                        onCancel={() => setPaletteModalVisible(false)}></ColorPalette>
                </div>

            </Modal>

            <ContextMenuModal
                visible={showChamferMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowChamferMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => { setSelectedChamferIcon(<FilletSvg />); setShowChamferMenu(false); }}><IconButton icon={<FilletSvg />} onClick={() => { emitCommand("FILLET") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedChamferIcon(<ChamferSvg />); setShowChamferMenu(false); }}><IconButton icon={<ChamferSvg />} onClick={() => { emitCommand("CHAMFER") }}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>

            <ContextMenuModal
                visible={showOperateMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowOperateMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<CopySvg />); setShowOperateMenu(false); }}>
                        <IconButton icon={<CopySvg />} onClick={() => {
                            emitCommand("COPY");
                            if (!registerContext.isSidebarCollapsed) {
                                emitter.emit(Emit_Event_Common_Tool.COPY);
                            }
                        }}></IconButton>
                    </MenuItem>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<RArraySvg />); setShowOperateMenu(false); }}><IconButton icon={<RArraySvg />} onClick={() => { emitCommand("RECTARRAY") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<CArraySvg />); setShowOperateMenu(false); }}><IconButton icon={<CArraySvg />} onClick={() => { emitCommand("POLARARRAY") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<PArraySvg />); setShowOperateMenu(false); }}><IconButton icon={<PArraySvg />} onClick={() => { emitCommand("PATHARRAY") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<MirrorSvg />); setShowOperateMenu(false); }}><IconButton icon={<MirrorSvg />} onClick={() => { emitCommand("MIRROR") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedOperateIcon(<OffsetSvg />); setShowOperateMenu(false); }}><IconButton icon={<OffsetSvg />} onClick={() => { emitCommand("OFFSET") }}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>

            <ContextMenuModal
                visible={showTextMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowTextMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => { setSelectedTextIcon(<TextSvg />); setShowTextMenu(false); }}><IconButton icon={<TextSvg />} onClick={() => { emitCommand("DTEXT") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedTextIcon(<TextAnnotationSvg />); setShowTextMenu(false); }}><IconButton icon={<TextAnnotationSvg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedTextIcon(<AxisNumber20Svg />); setShowTextMenu(false); }}><IconButton icon={<AxisNumber20Svg />} onClick={() => { emitCommand("GENGRIDNUMBER") }}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>

            <ContextMenuModal
                visible={showAnnoMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowAnnoMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => { setSelectedAnnoIcon(<Orthogonal20Svg />); setShowAnnoMenu(false); }}><IconButton icon={<Orthogonal20Svg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedAnnoIcon(<Slant20Svg />); setShowAnnoMenu(false); }}><IconButton icon={<Slant20Svg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedAnnoIcon(<TextAngleSvg />); setShowAnnoMenu(false); }}><IconButton icon={<TextAngleSvg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => { setSelectedAnnoIcon(<TextRadiusSvg />); setShowAnnoMenu(false); }}><IconButton icon={<TextRadiusSvg />}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>
        </div>
    )
}